/* eslint-disable react/display-name */
import React, { forwardRef } from "react";
import {
  Input,
  FormControl,
  InputGroup,
  Textarea,
} from "@chakra-ui/core";
import { isEmpty } from "lodash";
import { renderIcon, renderLabel, renderTextCounter } from "./InputElements";
import { errorMessages } from "../../../ErrorConfig/errorConfig";
import { pxToRem } from "../../../utils/dimensionConverter";

export const InputText = forwardRef(
  ({ ...props }, ref) => {
    const {
      full,
      errorValue,
      type,
      label,
      count,
      iconName,
      focusBorderColor,
      requiredMark,
      isDisabled
    } = props; 
    const isInvalid = !isEmpty(errorValue);
    const Type = type === "textarea" ? Textarea : Input;
    const textCounter = -count + parseInt(props.maxLength);

    return (
      <div ref={ref && null} className={`form__group${full ? " full" : ""}`}>
        <FormControl>
          {renderLabel(label, requiredMark)}
          {renderTextCounter(props.maxLength, textCounter)}
          <InputGroup
            style={{
              cursor: isDisabled ? "not-allowed" : "default",
            }}
          >
            <Type
              {...props}
              autoComplete="off"
              size="md"
              height={pxToRem(44)}
              variant="filled"
              rounded={pxToRem(12)}
              type={type || "text"}
              isInvalid={isInvalid}
              focusBorderColor={focusBorderColor || "#93328E"}
              errorBorderColor="#F26423"
            />
            {renderIcon(iconName)}
          </InputGroup>
          {errorValue && <div className="form__error">
          <div className="form__error-message">
            {errorValue === 'format' && errorMessages.invalidFormat}
            {errorValue === 'required' && errorMessages.requiredValueMissing}
          </div>
        </div>}
        </FormControl>
      </div>
    );
  }
);

export default InputText;
